export default {
  /* This section was auto-generated by bzs-helper ($Properties$) */
  createdOn: { field: 'createdOn', fieldType: 'date' },
  manufacturerModelCode: {
    field: 'manufacturerModelCode',
    fieldType: 'text',
    title: 'Manufacturer Code',
    required: true
  },
  manufacturerModelId: {
    field: 'manufacturerModelID',
    fieldType: 'numeric',
    title: 'Manufacturer ID'
  },
  manufacturerModelName: {
    field: 'manufacturerModelName',
    fieldType: 'text',
    title: 'Manufacturer Name',
    label: 'Manufacturer Name'
  },
  manufacturerModelSearchField: { field: 'manufacturerModelSearchField', fieldType: 'text' },
  modifiedOn: { field: 'modifiedOn', fieldType: 'date' }
};
